import { ReactNode } from "react";
import { cn } from "../../utils/class-names";
import { tv } from "tailwind-variants";
import { InfoIcon } from "../../icons";

const icon = tv({
  base: "w-6 h-6 sm:w-8 sm:h-8",
});

interface BannerProps {
  className?: string;
  icon?: ReactNode;
  content: ReactNode;
}

export function Banner({ className, icon, content }: BannerProps): JSX.Element {
  return (
    <Root className={className}>
      {icon ? <IconContainer>{icon}</IconContainer> : null}

      <Content>{content}</Content>
    </Root>
  );
}

Banner.icon = icon;
Banner.Icon = InfoIcon;

interface RootProps {
  className?: string;
  children?: ReactNode;
}

function Root({ className, children }: RootProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col gap-5 p-5 rounded-lg sm:flex-row sm:items-center sm:gap-8 bg-shale-800 text-shale-200",
        className
      )}
    >
      {children}
    </div>
  );
}

interface IconContainerProps {
  className?: string;
  children?: ReactNode;
}

function IconContainer({
  className,
  children,
}: IconContainerProps): JSX.Element {
  return <div className={cn("", className)}>{children}</div>;
}

interface ContentProps {
  className?: string;
  children?: ReactNode;
}

function Content({ className, children }: ContentProps): JSX.Element {
  return <div className={cn("flex-1", className)}>{children}</div>;
}
